<div class="modal-header">
    <button class="close" type="button" mat-dialog-close aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title" id="labelButtons">Connection Information</h4>
</div>
<div class="modal-body">
    <table class="mvd_table--primeng">
        <thead>
            <tr>
                <th class="w--icon"></th>
                <th>Status</th>
                <th>Server</th>
                <th>Time</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let response of responseHistory">
                <td class="w--icon"><span [ngClass]="response.styleClass"><i class="material-icons">favorite</i></span></td>
                <td>{{response.statusMessage}}</td>
                <td>{{response.serverName}}</td>
                <td>{{response.timestamp | date: 'medium'}}</td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td colspan="4" class="text-right">
                    <b>UI Version:</b> {{ uiVersion }} | <b>API Version:</b> {{ apiVersion }}
                </td>
            </tr>
        </tfoot>
    </table>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" mat-dialog-close aria-label="Close">Close</button>
    </div>
</div>